var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrossYogAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1211 9L14.5606 5.5605C15.1463 4.97475 15.1463 4.02525 14.5606 3.4395C13.9756 2.85375 13.0246 2.85375 12.4396 3.4395L9.00006 6.879L5.56056 3.4395C4.97556 2.85375 4.02456 2.85375 3.43956 3.4395C2.85381 4.02525 2.85381 4.97475 3.43956 5.5605L6.87906 9L3.43956 12.4395C2.85381 13.0252 2.85381 13.9747 3.43956 14.5605C3.73206 14.8537 4.11606 15 4.50006 15C4.88406 15 5.26806 14.8537 5.56056 14.5605L9.00006 11.121L12.4396 14.5605C12.7321 14.8537 13.1161 15 13.5001 15C13.8841 15 14.2681 14.8537 14.5606 14.5605C15.1463 13.9747 15.1463 13.0252 14.5606 12.4395L11.1211 9Z",
    fill: "#5F698B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossYogAdmin);
export default __webpack_public_path__ + "static/media/icon_cross_yog_admin.31b80b6b9d91a0d62cd8c6d6d9334d1d.svg";
export { ForwardRef as ReactComponent };